// extracted by mini-css-extract-plugin
export default {"W-0":"#FFFFFF","circle":"Gbb4204","iconMobile":"G26d5d9 Gbb4204","arrowDown":"G1365bd G5e65f6 Gb5dd03","arrowUp":"G1cc61a G5e65f6 Ge4ddb0"};